// src/app/core/ui/skeletons/CardSkeleton.tsx
import { motion } from "motion/react";

interface CardSkeletonProps {
  height?: string;
  width?: string;
  className?: string;
  animate?: boolean;
  children?: React.ReactNode;   // ← добавлено
}

export const CardSkeleton: React.FC<CardSkeletonProps> = ({
  height = "h-32",
  width = "w-full",
  className = "",
  animate = true,
  children,
}) => (
  <motion.div
    initial={animate ? { opacity: 0, y: 20 } : undefined}
    animate={animate ? { opacity: 1, y: 0 } : undefined}
    className={`rounded-2xl border border-border bg-card p-5 shadow-sm ${height} ${width} ${
      animate ? "animate-pulse" : ""
    } ${className}`}
  >
    {children ?? (
      <div className="space-y-3">
        <div className="h-4 w-3/4 rounded bg-muted" />
        <div className="h-4 w-1/2 rounded bg-muted" />
        {height !== "h-24" && <div className="h-4 w-5/6 rounded bg-muted" />}
      </div>
    )}
  </motion.div>
);